import clsx from "clsx";
import { DurationUnit, FormField, SwitchField, useError } from "common";
import { useField } from "formik";
import React, { useState } from "react";
import { TimePickerPopover } from "@/components/Common/TimePickerPopover";

export const MembershipExpiryRestriction = () => {
    const [{ value }, , { setValue }] = useField<number | null>("expiryInterval");
    const [isEnabled, setIsEnabled] = useState<boolean>(value ? value > 0 : false);
    const error = useError("expiryInterval");

    const handleToggle = (enabled: boolean) => {
        setValue(enabled ? 24 * 60 : null);
        setIsEnabled(enabled);
    };

    return (
        <FormField name="expiryInterval" label="Expiry">
            <SwitchField isChecked={isEnabled} onChange={handleToggle}>
                <span className="flex flex-wrap gap-x-1" onClick={(e) => e.stopPropagation()}>
                    Arrival must be within
                    {isEnabled ? (
                        <span>
                            <TimePickerPopover
                                showArrow
                                dataTestId="membership-expiry-interval"
                                unitOptions={[DurationUnit.DAY]}
                                classNames={{
                                    text: clsx(
                                        "px-0.5 pb-0.5 mx-1",
                                        error ? "!text-danger !border-danger" : "!text-black !border-black",
                                    ),
                                }}
                                value={value!}
                                submitOnApply={false}
                                onApply={setValue}
                            />
                        </span>
                    ) : (
                        <span>a limited window</span>
                    )}
                    from date of purchase
                </span>
            </SwitchField>
        </FormField>
    );
};
